import moment from "moment";
class instance {
  constructor(name, dateStart, dateEnd, repitXyear, overtimeLimit) {
    this.name = name;
    this.dateStart = dateStart
      ? moment.utc(dateStart).format("DD-MM-YYYY")
      : null;
    this.dateEnd = dateEnd ? moment.utc(dateEnd).format("DD-MM-YYYY") : null;
    this.dateStartInput = this.dateStart
      ? moment.utc(dateStart).format("YYYY-MM-DD")
      : null;
    this.dateEndInput = this.dateEnd
      ? moment.utc(dateEnd).format("YYYY-MM-DD")
      : null;
    this.repitXyear = repitXyear === true ? "✔️" : "";
    this.overtimeLimit = overtimeLimit;
  }
  static fromJson({ nombre, fecDesde, fecHasta, repiteXanio, topeMaxHExtras }) {
    return new instance(
      nombre,
      fecDesde,
      fecHasta,
      repiteXanio,
      topeMaxHExtras
    );
  }
}
export default instance;
